import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <g clipPath="url(#clip0_1283_17966)">
      <path
        fill="#686D7E"
        d="M9 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8M2 9c0-.622.082-1.24.246-1.84h2.487a15 15 0 0 0 0 3.68H2.246A7 7 0 0 1 2 9m3.619 0q0-.924.122-1.84H8.5v3.68H5.74A14 14 0 0 1 5.62 9M9.5 2.085c.656.221 1.292.867 1.798 1.846.337.65.6 1.406.783 2.229H9.5zm-1 0V6.16H5.919a9.2 9.2 0 0 1 .783-2.23c.506-.978 1.142-1.624 1.798-1.845m0 9.755v4.075c-.656-.221-1.292-.866-1.798-1.846a9.2 9.2 0 0 1-.783-2.229zm1 4.075V11.84h2.581a9.2 9.2 0 0 1-.783 2.23c-.506.978-1.142 1.624-1.798 1.845m0-5.075V7.16h2.76q.122.916.121 1.84 0 .924-.122 1.84zm3.767-3.68h2.487a7 7 0 0 1 0 3.68h-2.487q.116-.916.114-1.84 0-.924-.114-1.84m2.13-1h-2.294c-.202-.992-.511-1.906-.916-2.689a7 7 0 0 0-.614-.981 7.04 7.04 0 0 1 3.824 3.67m-8.97-3.67a7 7 0 0 0-.613.981c-.405.783-.715 1.697-.917 2.689H2.603a7.04 7.04 0 0 1 3.824-3.67m-3.824 9.35h2.294c.202.992.511 1.906.917 2.689q.264.517.613.981a7.04 7.04 0 0 1-3.824-3.67m8.97 3.67q.348-.464.613-.981c.405-.783.715-1.697.917-2.689h2.294a7.04 7.04 0 0 1-3.824 3.67"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1283_17966">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcon;
